import { useContext, useEffect, useState } from "react";
import { useQueryOperationsModelListForSelect } from "../../../core/_hooks";
import { Loader } from "../../../../../common/components/Loader/Loader";
import style from "./style.module.scss";
import { HiUserGroup } from "react-icons/hi2";
import { GoSearch } from "react-icons/go";
import { PlanningService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import { CustomPopConfirm } from "../../../../../common/components/PopConfirm/CustomPopConfirm";
import { OperationContext } from "../CreateOperation";

type ModelListType = {
  onConfirm: (e: any) => void;
};

export const ModelList = ({ onConfirm }: ModelListType) => {
  const { initialValue } = useContext(OperationContext);

  const { data: models, isLoading: isLoadingModel } =
    useQueryOperationsModelListForSelect({
      operationCategory: initialValue?.operationCategory?.id,
    });

  const [modelList, setModelList] = useState<Array<any>>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [selected, setSelected] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setModelList(models);
  }, [models]);

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText]);

  useEffect(() => {
    if (!isOpenConfirm) {
      setSelected(0);
    }
  }, [isOpenConfirm]);

  const handleSearch = (text: string) => {
    setModelList(() =>
      models?.filter((item: any) =>
        item?.label?.toLowerCase().includes(text?.toLowerCase())
      )
    );
  };

  const handleShowConfirmModal = () => {
    setIsOpenConfirm((prev: boolean) => !prev);
  };

  const handleConfirm = (id: number) => {
    setSelected(id);
    handleShowConfirmModal();
  };

  const onSaveHandler = async () => {
    console.log(selected);
    try {
      setIsLoading(true);

      const res = await PlanningService.getOneModel(selected);

      if (res?.status === HttpStatusCode.Ok) {
        onConfirm(res?.data);
        handleShowConfirmModal();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={style.model_list__container}>
      <Loader isLoading={isLoadingModel || isLoading} />

      <div className={style.model_list__search}>
        <GoSearch className={style.model_list__search_icon} />

        <input
          className={style.model_list__search_input}
          value={searchText}
          onChange={(val) => setSearchText(val.target.value)}
        />
      </div>
      <div className={style.model_list__wrapper}>
        {modelList?.map((item: any, key: number) => (
          <CustomPopConfirm
            title="Voulez-vous vraiment utiliser ce model ?"
            isOpen={isOpenConfirm && selected === item?.id}
            okText={"Oui"}
            cancelText="Non"
            onClose={handleShowConfirmModal}
            onConfirm={onSaveHandler}
          >
            <div
              className={style.model_list__item}
              key={key}
              onClick={() => handleConfirm(item?.id)}
            >
              <HiUserGroup className={style.model_list__item_icon} />
              {item?.label}
            </div>
          </CustomPopConfirm>
        ))}
      </div>
    </div>
  );
};
